/* eslint-disable react/no-children-prop */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView } from 'react-native';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import * as Layout from '@components/screen/Layout';
import Table from '@components/table/Table';
import SociollaText from '@components/sociolla/SociollaText';

import { MsOrder } from '@api/ms-order';
import {
  downloadFile,
  downloadDirectFile,
  generateMimeType,
} from '@global/helpers';

const tableStructure = {
  name: {
    head: 'Name',
    body: 'name',
    textStyle: { fontFamily: 'figtree-medium' },
  },
  url: {
    head: 'Url',
    body: 'url',
    maxWidth: 200,
  },
  action: {
    head: 'Action',
    type: 'action',
    actions: [
      {
        name: 'preview',
        label: 'Preview',
        style: {
          borderColor: Colors.blue3,
          backgroundColor: Colors.blue3,
        },
        textStyle: { color: Colors.white },
      },
      {
        name: 'download',
        label: 'Download',
        style: {
          borderColor: Colors.blue3,
          backgroundColor: Colors.white,
        },
        textStyle: { color: Colors.blue3 },
      },
    ],
  },
};

const SalesOrderDocumentScreen = (props) => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    let mounted = true;
    if (mounted && props?.route?.params?.id) {
      getOrderDetail(props.route.params.id);
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  const getOrderDetail = async (id) => {
    setLoading(true);
    try {
      const response = await MsOrder.getSalesOrderDetail(id);
      if (response?.data?.data && Object.keys(response.data.data).length) {
        const result = response.data.data;
        const finalData = result?.attachments?.length ? result.attachments : [];
        setTableData(finalData);
      } else {
        setTableData([]);
      }
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };

  const onPreview = (url) => {
    if (url) {
      const mimeType = generateMimeType(url);
      if (mimeType.startsWith('image/')) {
        window.open(url, '_blank');
      } else {
        const viewerUrl = `https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
          url,
        )}`;
        window.open(viewerUrl, '_blank');
      }
    }
  };

  const getExtFromSource = (url, name) => {
    const fromUrl = (url || '')
      .split('?')[0]
      .split('#')[0]
      .split('.')
      .pop()
      .toLowerCase();
    const fromName = (name || '').split('.').pop().toLowerCase();
    const validExts = [
      'jpg',
      'jpeg',
      'png',
      'gif',
      'pdf',
      'csv',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'ppt',
      'pptx',
    ];
    if (validExts.includes(fromUrl)) {
      return fromUrl;
    }
    if (validExts.includes(fromName)) {
      return fromName;
    }
    return '';
  };

  const onDownload = (url, name) => {
    if (url) {
      const ext = getExtFromSource(url, name);
      if (isWeb) {
        downloadDirectFile(url, 'sales-order-document', ext);
      } else {
        downloadFile(url, 'sales-order-document', ext, false, true);
      }
    }
  };

  const onMapAction = ({ data, index, action }) => {
    if (data) {
      if (action.name == 'preview') {
        onPreview(data.url);
      } else if (action.name == 'download') {
        onDownload(data.url, data.name);
      }
    }
  };

  return (
    <Layout.Container testID="sales-order-document-screen">
      {isWeb ? (
        <>
          <Layout.Back
            title={props.route.params?.reference || ''}
            onCallback={() =>
              props.navigation.navigate(
                'SalesOrderDetailScreen',
                props.route.params,
              )
            }
          />
          <Layout.Title title={`Attachments ${tableData?.length}`} />
          <Table
            testID="sales-order-document-web-table"
            structures={tableStructure}
            data={tableData}
            loading={loading}
            showSearch={false}
            showFilter={false}
            showPagination={false}
            hasCallback
            hasNoHide
            onMapAction={(val) => onMapAction(val)}
          />
        </>
      ) : (
        <ScrollView contentContainerStyle={{ width: '100%' }}>
          {loading ? (
            <Layout.Loader />
          ) : !loading && !tableData?.length ? (
            <View style={styles.noData}>
              <SociollaText style={styles.noDataText}>
                No data found
              </SociollaText>
            </View>
          ) : (
            tableData.map((item, idx) => (
              <Layout.ItemMobile
                testID={`sales-order-document-list-item-${idx}`}
                touchable
                onPress={() => onDownload(item.url, item.name)}
                key={idx}>
                <SociollaText>{item.name}</SociollaText>
              </Layout.ItemMobile>
            ))
          )}
        </ScrollView>
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  noData: {
    width: '100%',
    paddingHorizontal: 15,
    paddingVertical: 25,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  noDataText: { fontSize: 13 },
});

export default SalesOrderDocumentScreen;
